import { render, staticRenderFns } from "./PuzzleFormModal.vue?vue&type=template&id=42c61fb4&scoped=true&"
import script from "./PuzzleFormModal.vue?vue&type=script&lang=js&"
export * from "./PuzzleFormModal.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleFormModal.vue?vue&type=style&index=0&id=42c61fb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c61fb4",
  null
  
)

export default component.exports